import { Col, Row, Form, Input, Button, Card } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import Slider from "react-slick";

const { Meta } = Card;
const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent14 = () => {
  const settings = {
    dots: false,
    // arrows:false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <section className="py-5 home-modals-box">
        <Row justify={"center"}>
          <Col lg={18}>
            <Row className="happy-review">
              <Col xxl={9} xl={9} lg={9} md={9} sm={20} xs={23}>
                <img
                  src={ImageUrl("testimoimg.png")}
                  alt="vector"
                  className=""
                />
              </Col>
              <Col xxl={12} xl={12} lg={14} md={12} sm={20} xs={23}>
                <h3 className="font-goldman text-white  xldesktop:text-[50px] desktop:text-[40px] laptop:text-[36 px] tablet:text-[20px] mobile:text-[20px] xldesktop:leading-[75px]">
                What They Say Matter
                </h3>
                <p className="text-white text-[16px] antialiased">
                See how our luxurious chauffeur services are creating seamless travel
                experiences for our customers.
                </p>

                <div className="slider-container">
                  <Slider {...settings}>
                    <div>
                      <div className="slider-box">
                        <h4 className="font-goldman text-white text-[30px] leading-[40px]">
                          Wonderful Experience
                        </h4>
                        <p className="text-white text-[16px] leading-[26px] antialiased">
                        I recently used Luxury Car Chauffeur Service for my corporate event, and I was extremely impressed. The vehicles were immaculate, the chauffeurs were professional and courteous, and the overall experience was top-notch. I would highly recommend this service to anyone looking for reliable and luxurious transportation.
                        </p>
                        <div className="reviewprofile-box">
                          <img
                            src={ImageUrl("ryan.png")}
                            alt="vector"
                            className=""
                          />
                          <div>
                            <h4 className="text-customGold font-goldman xldesktop:text-[30px] laptop:text-[18px] xldesktop:leading-[40px]">
                            Ryan F.
                            </h4>
                            <p className="text-white text-[16px] leading-[26px] antialiased">
                              Happy Client{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="slider-box">
                        <h4 className="font-goldman text-white text-[30px] leading-[40px]">
                          Wonderful Experience
                        </h4>
                        <p className="text-white text-[16px] leading-[26px] antialiased">
                        I’ve used Luxury Car Chauffeur Service several times for airport transfers and personal tours. The service is always impeccable. The cars are clean and comfortable, and the chauffeurs are knowledgeable and helpful. I’ll definitely continue using them for my future transportation needs.
                        </p>
                        <div className="reviewprofile-box">
                          <img
                            src={ImageUrl("kevin.png")}
                            alt="vector"
                            className=""
                          />
                          <div>
                            <h4 className="text-customGold font-goldman xldesktop:text-[30px] laptop:text-[18px] xldesktop:leading-[40px]">
                            Kevin B.
                            </h4>
                            <p className="text-white text-[16px] leading-[26px] antialiased">
                              Happy Client{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="slider-box">
                        <h4 className="font-goldman text-white text-[30px] leading-[40px]">
                          Wonderful Experience
                        </h4>
                        <p className="text-white text-[16px] leading-[26px] antialiased">
                        I recently used Luxury Car Chauffeur Service for my wedding day, and it was the perfect choice. The car was beautiful, the chauffeur was attentive, and the overall experience was stress-free. I couldn’t have asked for a better way to arrive at my wedding.
                        </p>
                        <div className="reviewprofile-box">
                          <img
                            src={ImageUrl("reviewpic.png")}
                            alt="vector"
                            className=""
                          />
                          <div>
                            <h4 className="text-customGold font-goldman xldesktop:text-[30px] laptop:text-[18px] xldesktop:leading-[40px]">
                            Jennifer K
                            </h4>
                            <p className="text-white text-[16px] leading-[26px] antialiased">
                              Happy Client{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="slider-box">
                        <h4 className="font-goldman text-white text-[30px] leading-[40px]">
                          Wonderful Experience
                        </h4>
                        <p className="text-white text-[16px] leading-[26px] antialiased">
                        I’ve been a member of Luxury Car Chauffeur Service for several years, and I’ve always been satisfied with their service. The discounted rates are great, and the convenience of having a reliable chauffeur available at any time is invaluable. I highly recommend this service to anyone who values luxury and convenience.
                        </p>
                        <div className="reviewprofile-box">
                          <img
                            src={ImageUrl("oliver.png")}
                            alt="vector"
                            className=""
                          />
                          <div>
                            <h4 className="text-customGold font-goldman xldesktop:text-[30px] laptop:text-[18px] xldesktop:leading-[40px]">
                            Oliver M.
                            </h4>
                            <p className="text-white text-[16px] leading-[26px] antialiased">
                              Happy Client{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="slider-box">
                        <h4 className="font-goldman text-white text-[30px] leading-[40px]">
                          Wonderful Experience
                        </h4>
                        <p className="text-white text-[16px] leading-[26px] antialiased">
                        I recently used Luxury Car Chauffeur Service for a night out with friends, and it was a fantastic experience. The Sprinter van was spacious and comfortable, and the chauffeur was friendly and accommodating. We had a great time and will definitely use this service again.
                        </p>
                        <div className="reviewprofile-box">
                          <img
                            src={ImageUrl("ben.png")}
                            alt="vector"
                            className=""
                          />
                          <div>
                            <h4 className="text-customGold font-goldman xldesktop:text-[30px] laptop:text-[18px] xldesktop:leading-[40px]">
                            Ben H.
                            </h4>
                            <p className="text-white text-[16px] leading-[26px] antialiased">
                              Happy Client{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </Slider>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent14;
